import vert from './glsl/stonefigure.vert.glsl';
import frag from './glsl/stonefigure.frag.glsl';
export default { frag, vert };